import React from 'react';
import { NavLink } from 'react-router-dom';
import Header from './../Common/Header';
import Footer from './../Common/Footer';
import Banner from './../Elements/Banner';

var bnrimg = require('./../../images/s6/b1.jpg');

class Services_6 extends React.Component {
  render() {
    return (
      <>
        <Header />
        <div className="page-content">
          <Banner
            title="Design Precision. Installation Discipline. Performance Delivered."
            pagename="Full MEP Design & Installation Works"
            bgimage={bnrimg}
          />

          <div className="section-full p-tb80 inner-page-padding">
            <div className="container">
              <div className="blog-single-wrap-width">
                <div className="blog-post date-style-3 blog-detail text-black">
                  <div className="mt-post-media clearfix m-b30">
                    <ul className="grid-post">
                      <li>
                        <div className="portfolio-item">
                          <img
                            className="img-responsive"
                            src={require("./../../images/s6/b2.jpg")}
                            alt="MEP Design & Installation"
                          />
                        </div>
                      </li>
                    </ul>
                  </div>

                  <div className="mt-post-title">
                    <h3 className="post-title font-weight-600">
                      Full MEP Design & Installation Works
                    </h3>
                  </div>

                  <div className="mt-post-text">
                    <p><strong>“Mission-critical systems demand precision design and flawless execution.”</strong></p>

                    <p>
                      At <strong>I‑Smart Engineering Works</strong>, we deliver integrated Mechanical, Electrical and Plumbing (MEP) solutions built with military-grade precision. Our holistic approach ensures every component—from pipelines and ducts to wiring and mechanical systems—is synchronized for maximum performance and reliability.
                    </p>

                    <p>
                      Whether it's a commercial tower, hospital, industrial facility or data center, our engineers design and install systems to exact tolerances, meeting international standards and operational rigor.
                    </p>

                    <h4 className="font-weight-600">Our MEP Capabilities Include:</h4>
                    <ul className="list-angle-right">
                      <li>Comprehensive MEP system planning & CAD design</li>
                      <li>HVAC layout, ducting, and ventilation integration</li>
                      <li>Plumbing, drainage, and sanitary system installations</li>
                      <li>Electrical power, lighting, backup & automation wiring</li>
                      <li>On-site project management and commissioning support</li>
                      <li>AMC packages for long-term system care & performance</li>
                    </ul>

                    <blockquote className="bg-dark text-white author-quote">
                      <h4 className="m-b0">
                        “Onboard fleet systems run on discipline. Your building systems should too.” <i className="fa fa-quote-right" />
                      </h4>
                      <div className="p-t15 text-white">
                        <strong className="text-primary">Commander S. Patel</strong>
                        <span>Naval Engineering Corps</span>
                      </div>
                    </blockquote>

                    <p>
                      We follow clean-site protocols, strict testing procedures, and precision commissioning to deliver full-fledged MEP systems that operate flawlessly from day one. Your building’s systems deserve mission-level readiness—and that’s our promise.
                    </p>

                    {/* <div className="row">
                      <div className="col-md-4 col-sm-4">
                        <div className="mt-box m-b30">
                          <div className="mt-media">
                            <img src={require("./../../images/blog/large-blog.jpg")} alt="MEP CAD Design" />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4 col-sm-4">
                        <div className="mt-box m-b30">
                          <div className="mt-media">
                            <img src={require("./../../images/blog/large-blog2.jpg")} alt="HVAC & Plumbing Layout" />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4 col-sm-4">
                        <div className="mt-box m-b30">
                          <div className="mt-media">
                            <img src={require("./../../images/blog/large-blog3.jpg")} alt="Electrical Commissioning" />
                          </div>
                        </div>
                      </div>
                    </div> */}

                    <p>
                      <strong>Ready to deploy MEP systems that operate like clockwork?</strong> Contact us for a full-scale design and execution roadmap tailored to your project’s mission objectives.
                    </p>
                  </div>

                  <div className="autor-post-tag-share bdr-t-1 bdr-solid bdr-gray p-t20">
                    <div className="row">
                      <div className="col-md-6 col-sm-6">
                        <div className="widget widget_tag_cloud">
                          <h4 className="tagcloud">Tags</h4>
                          <div className="tagcloud">
                            <NavLink to="#">MEP Design</NavLink>&nbsp;
                            <NavLink to="#">HVAC</NavLink>&nbsp;
                            <NavLink to="#">Plumbing</NavLink>&nbsp;
                            <NavLink to="#">Electrical</NavLink>&nbsp;
                            <NavLink to="#">Commissioning</NavLink>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }
}

export default Services_6;
